import { Entity, Language } from '@nx-smartmonkey/shared/domain';
import { removeEmpty } from '@nx-smartmonkey/shared/helpers';

export interface UserBaseNotifications {
  analytics_email: boolean;
}

export interface UserBaseValidation {
  email_validated: boolean;
  phone_validated: boolean;
}

export interface UpdateUserBaseProps {
  first_name?: string | null;
  last_name?: string | null;
  phone?: string;
  language?: Language;
  notifications?: UserBaseNotifications;
}

export interface UserBaseProps {
  avatar_url?: string;
  organization_id: string;
  default_project_id: string;
  email: string;
  first_name?: string;
  last_name?: string;
  phone?: string;

  active: boolean;
  roles: string[];
  language: Language;
  validation: UserBaseValidation;
  created_at: Date;

  notifications: UserBaseNotifications;

  deleted: boolean;
}

export class UserBase extends Entity<UserBaseProps> {
  private _avatar: string | undefined;

  get id(): string {
    return this._id!;
  }

  get avatar_url(): string | undefined {
    return this.props.avatar_url;
  }

  set avatar_url(avatarUrl: string | undefined) {
    this.props.avatar_url = avatarUrl;
  }

  get user_avatar(): string | undefined {
    return this._avatar;
  }

  set user_avatar(userAvatar: string | undefined) {
    this._avatar = userAvatar;
  }

  get organization_id(): string {
    return this.props.organization_id;
  }

  get default_project_id(): string {
    return this.props.default_project_id;
  }

  get email(): string {
    return this.props.email;
  }

  get first_name(): string | undefined {
    return this.props.first_name;
  }

  set first_name(firstName: string | undefined) {
    this.props.first_name = firstName;
  }

  get last_name(): string | undefined {
    return this.props.last_name;
  }

  set last_name(lastName: string | undefined) {
    this.props.last_name = lastName;
  }

  get phone(): string | undefined {
    return this.props.phone;
  }

  set phone(phone: string | undefined) {
    this.props.phone = phone;
  }

  get active(): boolean {
    return this.props.active;
  }

  get roles(): string[] {
    return this.props.roles;
  }

  get language(): Language {
    return this.props.language;
  }

  set language(language: Language) {
    this.props.language = language;
  }

  get validation(): UserBaseValidation {
    return this.props.validation;
  }

  get created_at(): Date {
    return this.props.created_at;
  }

  get notifications(): UserBaseNotifications {
    return this.props.notifications;
  }

  set notifications(notifications: UserBaseNotifications) {
    this.props.notifications = notifications;
  }

  get deleted(): boolean {
    return this.props.deleted;
  }

  protected constructor(props: UserBaseProps, id: string) {
    super(props, id);
  }

  static create(props: UserBaseProps, id: string): UserBase {
    return new UserBase(props, id);
  }

  update(props: UpdateUserBaseProps) {
    removeEmpty(props);
    if (props.first_name) this.first_name = props.first_name;
    if (props.last_name) this.last_name = props.last_name;
    if (props.phone !== undefined) this.phone = props.phone;
    if (props.language) this.language = props.language;
    if (props.notifications) this.notifications = props.notifications;
  }

  isTranslator() {
    return this.roles.includes(`translator`);
  }
  validateEmail() {
    this.props.validation.email_validated = true;
  }
}
